
  $(".toggle-filters").click(function(){
    // $("#collectionFilters").toggle();
    $("#collectionFilters").toggleClass("active");
      // alert('sdklfjsdkl');
  });
$('.menu-toggle').click(function(){
    $("body").toggleClass("show-nav");
});